import { LoanFormat } from './LoanFormat';
import { GroupBy } from '../js/store/constants';

/**
 * Represents a set of products that share a reference to a specific source bundle.
 */
export type BundleGroupItem = {
    readonly id: undefined;
    readonly bundleId: string;
    readonly title?: string;
    readonly catalogueBundleSize?: number;
    readonly coverUrl?: string;
    readonly description?: string;
    readonly eaudiobookCopyAmount?: number;
    readonly eaudiobookProductAmount?: number;
    readonly eaudiobookProductStockAmount?: number;
    readonly ebookCopyAmount?: number;
    readonly ebookProductAmount?: number;
    readonly ebookProductStockAmount?: number;
    readonly epressCopyAmount?: number;
    readonly epressProductAmount?: number;
    readonly epressProductStockAmount?: number;
    readonly salesTag?: string;
    readonly loanFormat?: LoanFormat;
    readonly netValue?: number;
    readonly basePrice?: number;
    readonly currency?: string;
    readonly savedPercentage?: number;
    readonly savedValue?: number;
};

/**
 * Represents a set of products that share a reference to a specific source list.
 */
export type SelectionListGroupItem = {
    readonly id: string;
    readonly bundleId: undefined;
    readonly listName?: string;
    readonly eaudiobookProductAmount?: number;
    readonly eaudiobookProductStockAmount?: number;
    readonly eaudiobookCopyAmount?: number;
    readonly ebookProductAmount?: number;
    readonly ebookProductStockAmount?: number;
    readonly ebookCopyAmount?: number;
    readonly epressProductAmount?: number;
    readonly epressProductStockAmount?: number;
    readonly epressCopyAmount?: number;
    readonly netValue?: number;
    readonly currency?: string;
};

export type GroupItem = BundleGroupItem | SelectionListGroupItem;

export const isBundleGroupItem = (item: GroupItem): item is BundleGroupItem => {
    return typeof item.bundleId === 'string';
};

export type GroupingState = {
    readonly key: GroupBy; // e.g. "products" | "bundles"
    readonly label: string; // e.g. "Curated Collections"
    id?: string | null;
};

export const getGroupItemId = (item: GroupItem): string => {
    if (isBundleGroupItem(item)) {
        return item.bundleId;
    }
    return item.id;
};
